export function isNullOrWhitespace(i: string | null | undefined): boolean {
    return i == null || /^\s*$/.test(i);
}
export function stringCoalesce(...list: (string | null | undefined)[]): string | null | undefined {
    return stringCoalesceList(list);
}
export function stringCoalesceList(list: (string | null | undefined)[]): string | null | undefined {
    let result = null;
    if (list.length) {
        for (let index = 0; index < list.length; index++) {
            if (isNullOrWhitespace(result)) {
                result = list[index];
            }
        }
    }
    return result;
}
